<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo" >
      <el-menu-item v-if="permissionCodes.indexOf('001019000') !== -1" index="1" @click="toNewRouter('occupancy-approval')" >
        <i class="el-icon-damai-ic_hetongshenpi"></i>
        <span slot="title">入住申请审批</span>
      </el-menu-item>
      <el-menu-item index="2" @click="toNewRouter('contract-approval')" >
        <i class="el-icon-damai-ic_hetongshenpi"></i>
        <span slot="title">合同审批</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('electricity-approval')" >
        <i class="el-icon-damai-ic_dianfeichongzhishenpi"></i>
        <span slot="title">电费充值审批</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('water-approval')" >
        <i class="el-icon-damai-ic_shuifeichongzhishenpi"></i>
        <span slot="title">水费充值审批</span>
      </el-menu-item>
<!--      <el-menu-item index="5" @click="toNewRouter('steam-approval')" >
        <i class="el-icon-damai-ic_zhengqichongzhishenpi1"></i>
        <span slot="title">蒸汽充值审批</span>
      </el-menu-item>
      <el-menu-item index="6" @click="toNewRouter('gas-approval')" >
        <i class="el-icon-damai-ic_ranqichongzhishenpi"></i>
        <span slot="title">燃气充值审批</span>
      </el-menu-item>-->
      <el-menu-item index="7" @click="toNewRouter('revise-approval')" >
        <i class="el-icon-damai-ic_zhangdanxiugaishenpi"></i>
        <span slot="title">账单修改审批</span>
      </el-menu-item>
<!--      <el-menu-item index="8" @click="toNewRouter('attendance-approval')" >
        <i class="el-icon-damai-ic_kaoqinshenpi"></i>
        <span slot="title">考勤审批</span>
      </el-menu-item>-->

      <el-submenu index="9">
        <template slot="title">
          <i class="el-icon-damai-ic_churukuguanli"></i>
          <span>车位租赁审批</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="9-1" @click="toNewRouter('parking-apply-approval')">车位申请</el-menu-item>
          <el-menu-item index="9-2" @click="toNewRouter('parking-back-approval')">车位退还</el-menu-item>
        </el-menu-item-group>
      </el-submenu>

<!--      <el-menu-item index="10" @click="toNewRouter('political-communication-approval')" >
        <i class="el-icon-damai-ic_shujushangbaoshenpi"></i>
        <span slot="title">数据上报</span>
      </el-menu-item>-->

      <el-menu-item index="11" @click="toNewRouter('free-code-approval')" >
        <i class="el-icon-damai-ic_mianfeimashouquanrenshenpi"></i>
        <span slot="title">免费码授权人审批</span>
      </el-menu-item>

<!--      <el-menu-item index="12" @click="toNewRouter('suggestion-approval')" >
        <i class="el-icon-damai-ic_tousujianyi"></i>
        <span slot="title">投诉建议</span>
      </el-menu-item>-->


<!--      <el-menu-item index="10" @click="toNewRouter('resource-center-log')" v-if="permissionCodes.indexOf('001010000') !== -1">-->
<!--        <i class="el-icon-damai-ic_caozuorizhi"></i>-->
<!--        <span slot="title">操作日志</span>-->
<!--      </el-menu-item>-->
      <!-- <el-menu-item index="13" @click="toNewRouter('repair-approval')" >
        <i class="el-icon-damai-ic_baoxiushenpi"></i>
        <span slot="title" class="position">报修审批</span>
      </el-menu-item> -->
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  1: ['occupancy-approval'],
  2: ["contract-approval"],
  3: ["electricity-approval"],
  4: ["water-approval"],
  5: ["steam-approval"],
  6: ["gas-approval"],
  7: ["revise-approval"],
  8: ["attendance-approval"],
  "9-1": ["parking-apply-approval", "parking-apply-detail"],
  "9-2": ["parking-back-approval", "parking-back-detail"],
  '10': ['political-communication-approval', 'political-communication-approval-detail'],
  11: ["free-code-approval"],
  12: ["suggestion-approval"],
  13: ["repair-approval"],
});
export default {
  name: "resource-nav",
  mixins: [navMixin],
  data() {
    return {
      yqCode: "",
      isCollapse: bus.global.isCollapse,
      indexOfRouterNameEntities,
      permissionCodes: ""
    };
  },
  created() {
    this.yqCode = bus.global.yqCode;
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", data => {
      this.isCollapse = data;
    });
  },
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    }
  },
  methods: {
    toNewRouter(name) {
      if (name === "housing-management") {
        window.sessionStorage.setItem(
          "housingManagementPageHousingTabState",
          ""
        );
        window.sessionStorage.setItem(
          "housingManagementPageBuildingTabState",
          ""
        );
      }
      this.$router.push({
        name: name
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/PendingItems/PendingNav.vue